
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/write-for-us",
      function () {
        return require("private-next-pages/write-for-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/write-for-us"])
      });
    }
  